import axios from '../utils/axios';

export default function createCreditNote(adminId, invoiceId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-invoice-admin/v2/invoice/${invoiceId}/generateCreditnote`, body);
};
